import { ReactNode } from 'react';
import { Stack } from 'components';

import style from '../noteEdit.module.scss';

type FieldsContainerProps = {
  children: ReactNode;
  expanded?: boolean;
};

export const FieldsContainer = ({ children, expanded = true }: FieldsContainerProps) => {
  if (!expanded) return null;

  return <>{children}</>;
};

// Layout primitives for composing field layouts
type RowProps = {
  children: ReactNode;
};

export const Row = ({ children }: RowProps) => {
  return <div className={style.inputRow}>{children}</div>;
};

type HalfRowProps = {
  children: ReactNode;
};

export const HalfRow = ({ children }: HalfRowProps) => {
  return <div className={style.halfRow}>{children}</div>;
};

type FullWidthProps = {
  children: ReactNode;
  marginBottom?: string;
};

export const FullWidth = ({ children, marginBottom = '4px' }: FullWidthProps) => {
  return (
    <Stack width="100%" mb={marginBottom}>
      {children}
    </Stack>
  );
};

// Attach sub-components to FieldsContainer
FieldsContainer.Row = Row;
FieldsContainer.HalfRow = HalfRow;
FieldsContainer.FullWidth = FullWidth;
